var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
var HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
var StyledCheckbox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  margin-top: -3px;\n  cursor: pointer;\n  height: 28px;\n  width: 28px;\n  ", ":checked + & {\n    background-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  margin-top: -3px;\n  cursor: pointer;\n  height: 28px;\n  width: 28px;\n  ", ":checked + & {\n    background-color: ", ";\n  }\n"])), function (props) { return props.theme.colors.background; }, HiddenCheckbox, function (props) { return props.theme.colors.primary; });
var CheckboxContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n"])));
function Checkbox(_a) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, props = __rest(_a, ["checked"]);
    return (React.createElement(CheckboxContainer, null,
        React.createElement(HiddenCheckbox, __assign({ checked: checked }, props)),
        React.createElement(StyledCheckbox, { checked: checked })));
}
export default Checkbox;
var templateObject_1, templateObject_2, templateObject_3;
